import { authContext, profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction, useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  updateApplicantResumeProfileRoute,
  updateEmployerProfilePersonalRoute,
} from '@features/profile';
import axiosInstance from '@server/axiosInstance';

type UseUpdatePersonalProfileProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  onSuccess?: () => void;
};

export const useUpdatePersonalProfile = ({
  setErrorText = () => {},
  onSuccess = () => {},
}: UseUpdatePersonalProfileProps) => {
  const {
    authData: { user },
  } = useContext(authContext);

  const client = useQueryClient();

  const {
    mutate: updatePersonalProfile,
    isLoading: isUpdatingPersonalProfile,
  } = useMutation({
    mutationFn: (variables: {
      email?: string;
      first_name?: string;
      middle_name?: string;
      last_name?: string;
      phone?: string;
      birthdayDay?: string;
      birthdayMonth?: string;
      birthdayYear?: string;
    }) =>
      axiosInstance
        .post(
          user?.company
            ? updateEmployerProfilePersonalRoute
            : updateApplicantResumeProfileRoute,
          variables,
        )
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries([profileKey]);

        onSuccess();
      }
    },
    onError: () => setErrorText(errorMessage),
  });

  return {
    updatePersonalProfile,
    isUpdatingPersonalProfile,
  };
};
